import { takeLatest, all, put, call } from 'redux-saga/effects';
import delay from '@redux-saga/delay-p';
import RecoverPasswordPanelActions from './actions';

function* recoverPasswordRequestHandler({ payload: { formRef, isValid } }) {
  if (!isValid) {
    yield call(delay, 500);
    yield put(RecoverPasswordPanelActions.onRecoverPasswordFailure());
  } else {
    formRef.method = 'post';
    formRef.submit();
  }
}

function* recoverPasswordPanelSagas() {
  yield all([
    takeLatest(RecoverPasswordPanelActions.onRecoverPasswordRequest.getType(), recoverPasswordRequestHandler),
  ]);
}

export default recoverPasswordPanelSagas;
